import { EMPTY_OBJECT } from 'commons-ui';
import { ELaunchWidgetType } from '../utils/constants';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				const pathSufix: string =
					rowData.launchWidgetType === ELaunchWidgetType.SINGLE_VIDEO_BASED ? 'launchWidgetEdit' : 'edit';
				history.push({
					pathname: `/dashboard/notices/${pathSufix}`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				const pathSufix: string =
					rowData.launchWidgetType === ELaunchWidgetType.SINGLE_VIDEO_BASED ? 'launchWidgetClone' : 'clone';
				history.push({
					pathname: `/dashboard/notices/${pathSufix}`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/notices/selectWidgetType',
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
